import { Controller } from "@hotwired/stimulus"

// Capture le contexte technique du demandeur pour faciliter le diagnostic.
export default class extends Controller {
  static targets = ["viewport", "screen", "language", "timezone", "referrer", "platform", "submit"]

  connect() {
    const set = (name, value) => { if (this[`has${name[0].toUpperCase()}${name.slice(1)}Target`]) this[`${name}Target`].value = value || "" }
    set("viewport", `${window.innerWidth}×${window.innerHeight}`)
    set("screen", `${screen.width}×${screen.height} @${window.devicePixelRatio || 1}x`)
    set("language", navigator.language)
    set("timezone", Intl.DateTimeFormat().resolvedOptions().timeZone)
    set("referrer", document.referrer)
    set("platform", navigator.userAgentData?.platform || navigator.platform)

    this.element.addEventListener("submit", () => {
      if (!this.hasSubmitTarget) return
      this.submitTarget.disabled = true
      this.submitTarget.innerHTML = "Envoi en cours…"
    })
  }
}
